var React = require('react');

function RightArrowAlternativeIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.75311 10L6.12456 9.37678L9.83194 5.67472H0.563477V4.77983H9.83194L6.12456 1.07777L6.75311 0.454546L11.5258 5.22727L6.75311 10Z","fill":"currentColor"}));
}

RightArrowAlternativeIconInline.defaultProps = {"width":"12","height":"10","viewBox":"0 0 12 10","fill":"none"};

module.exports = RightArrowAlternativeIconInline;

RightArrowAlternativeIconInline.default = RightArrowAlternativeIconInline;
